/* eslint-disable indent */
/* eslint-disable no-nested-ternary */
import React from 'react';
import { useParams } from 'react-router-dom';
import { useBlogPost } from '../utils/blogs';
import { BlogPostTemplate } from '../components/blog/blogPost';

const BlogPostPage = () => {
  const { id } = useParams();
  const { isLoading, isError, error, isSuccess, blogPost } = useBlogPost(id);
  return (
    <div>
      {isError ? <p>{error}</p> : null}
      {isLoading
        ? 'Loading...'
        : isSuccess
        ? blogPost.length &&
          blogPost.map((blog) => (
            <>
              <BlogPostTemplate
                avatar={blog.fields?.authorAvatar.fields.file.url}
                category={blog.fields?.category}
                author={blog.fields?.author}
                title={blog.fields?.title}
                date="Sep 5st ・ 8 min"
                content={blog.fields?.body}
                heroImg={blog.fields?.cover_image.fields.file.url}
              />
            </>
          ))
        : null}
    </div>
  );
};

export default BlogPostPage;
